<template>
    <div class="infoengine risk-level-page">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-12 filter-title-section">
                    <h2 class="filter-heading">
                        Risk Level Review Configuration
                    </h2>
                </div>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'tablet-table-small-min-width',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <template slot="level" slot-scope="data">
                    {{ data.item.level | capitalize }}
                </template>
                <template slot="involvement.maker" slot-scope="data">
                    <status-type-icon
                        :status-type="data.value"
                    ></status-type-icon>
                </template>
                <template slot="involvement.checker" slot-scope="data">
                    <status-type-icon
                        :status-type="data.value"
                    ></status-type-icon>
                </template>
                <template slot="involvement.approver" slot-scope="data">
                    <status-type-icon
                        :status-type="data.value"
                    ></status-type-icon>
                </template>
                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-risk-level-review-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>

        <add-risk-level-review-popup
            :title="title"
        ></add-risk-level-review-popup>
        <base-records
            path="configurations/risk-level-reviews"
            :query="query"
            :reset="reset"
            :show-pagination="false"
        ></base-records>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import addRiskLevelReviewPopup from '@/components/popups/RiskLevelReviewPopup.vue'
import statusTypeIcon from '@/components/AlertType.vue'
import _ from 'lodash'

export default {
    components: {
        addRiskLevelReviewPopup,
        statusTypeIcon,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'level',
                    label: 'Risk Level',
                    sortable: true,
                    formatter: (value) => {
                        return _.startCase(value)
                    },
                },

                {
                    key: 'involvement.maker',
                    label: 'Maker Involvement',
                    class: 'text-center',
                },
                {
                    key: 'involvement.checker',
                    label: 'Checker Involvement',
                    class: 'text-center',
                },
                {
                    key: 'involvement.approver',
                    label: 'Approver Involvement',
                    class: 'text-center',
                },
                {
                    key: 'alertType',
                    label: 'Alert Type',
                    formatter: (value) => {
                        return _.startCase(value)
                    },
                    // formatter: (value, key, item) => {
                    //     return `${item.alertType.charAt(0).toUpperCase() +
                    //         value.slice(1).replace(/_/g, ' ')}`
                    // },
                },
                {
                    key: 'action',
                    label: 'ACTION',
                },
            ],
            title: '',
            query: {
                startAt: 1,
                keyword: '',
                perPage: 100,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'alertType',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method
    }, // End of Component > mounted
} // End of export default
</script>
